import { render, staticRenderFns } from "./knowledgeBaseManagementList.vue?vue&type=template&id=f03228c2&"
import script from "./knowledgeBaseManagementList.vue?vue&type=script&lang=js&"
export * from "./knowledgeBaseManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports